// SelectedFilters
import React from 'react';
import PropTypes from 'prop-types';

const SelectedFilters = ({
  selectedFilters,
  clearFilters,
  removeFilter,
  hasSearch,
  clearLabel,
  pillStyle,
}) => {
  const hasSelection = Object.keys(selectedFilters)
    .filter(filterKey => (Array.isArray(selectedFilters[filterKey]) && selectedFilters[filterKey].length > 0)).length > 0;

  if (!hasSelection && !hasSearch) {
    return <div className="selected-filters-container" />;
  }

  const activeItems = Object.keys(selectedFilters)
    .filter(filterKey => Array.isArray(selectedFilters[filterKey]) && selectedFilters[filterKey].length > 0)
    .reduce((items, filterKey) => items.concat(selectedFilters[filterKey]), []);

  if (pillStyle) {
    return (
      <div className="selected-filters-container">
        <div className="blog-selected-filters d-flex flex-wrap align-items-center gap-2 mt-3">
          {activeItems.map(item => (
            <button
              key={item}
              type="button"
              className="blog-selected-filter-btn btn rounded-pill bg-white text-dark d-inline-flex align-items-center fw-normal gap-2 mw-100 px-3 py-1 lh-sm text-start text-wrap"
              aria-label={`Remove ${item} filter`}
              onClick={() => removeFilter(item)}
            >
              <span className="blog-selected-filter-remove flex-shrink-0 fw-normal lh-1" aria-hidden="true">{'\u00D7'}</span>
              <span className="blog-selected-filter-label text-decoration-underline">{item}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="selected-filters-container">
      <div className="selected-filters">
        {hasSelection ? (
          <ul role="menu" id="selected-filters-list" className="list-unstyled selected-filters-list">
            {activeItems.map(item => (
              <li role="menuitem" key={item}>
                <button aria-label={`Remove ${item} Filter`} className="remove-selection-button btn-transparent" type="button" onClick={() => removeFilter(item)}>{item}<span className="remove-selection-icon" /></button>
              </li>
            ))}
          </ul>
        ) : false}
        <button id="clear-filters" className="clear-filters btn-transparent link link-secondary px-0" type="button" onClick={() => clearFilters()}>{clearLabel}</button>
      </div>
    </div>
  );
};

SelectedFilters.defaultProps = {
  hasSearch: false,
  clearLabel: 'Clear filters',
  pillStyle: false,
};

SelectedFilters.propTypes = {
  removeFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  selectedFilters: PropTypes.objectOf(PropTypes.array),
  hasSearch: PropTypes.bool,
  clearLabel: PropTypes.string,
  pillStyle: PropTypes.bool,
};

export default SelectedFilters;
